import ky from "ky";

import { defaultOptions } from "./default-options.js";

export const http = ky.extend(defaultOptions);
